/**
 * cn — tiny classNames joiner for the Green Bay UI kit.
 *
 * Joins truthy class fragments with a space. Deliberately dependency-free
 * (no clsx / tailwind-merge) to avoid touching package.json during the live
 * migration. Conflicting utilities are resolved by authoring intent — keep the
 * "winning" class last and don't pass two competing utilities for one property.
 */
export type ClassValue = string | number | false | null | undefined;

export function cn(...parts: ClassValue[]): string {
  let out = '';
  for (const p of parts) {
    if (!p && p !== 0) continue;
    out += (out ? ' ' : '') + p;
  }
  return out;
}
